<template>
    <div class="inventory-overview">
        <div class="page-header">
            <h1 class="page-title">Vue d'ensemble de l'inventaire</h1>
        </div>

        <div class="content-placeholder">
            <p>Contenu à venir...</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InventoryOverview',
    data() {
        return {
            //
        }
    }
}
</script>

<style scoped>
.inventory-overview {
}

.page-header {
    margin-bottom: 30px;
}

.page-title {
    font-size: 28px;
    font-weight: 600;
    color: #1a202c;
}

.content-placeholder {
    background: white;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.content-placeholder p {
    color: #718096;
    font-size: 16px;
}
</style>

